import { localizable } from 'components/Localization';
import { observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import DropDownField from '../../../../components/DropDownField';

@localizable
@observer
export default class RoundTypeSelector extends Component {
  handleSelect = (type) => {
    const { onSelect } = this.props;
    if (onSelect) onSelect(type.key);
  };

  render() {
    const { rounds, disabled, t } = this.props;
    const selected = rounds.find((r) => r.selected);
    const tooltip = t('bidding type tooltip');
    return (
      <Fragment>
        <DropDownField
          placeholder={t('Select a bidding type')}
          label={t('Bidding type')}
          ariaLabel={t('Bidding type')}
          selectedKey={!!selected ? selected.type : undefined}
          options={rounds.map((r) => {
            return { key: r.type, text: t(`roundtype::${r.type}`) };
          })}
          onChanged={this.handleSelect}
          disabled={disabled}
          tooltip={tooltip !== 'bidding type tooltip' ? tooltip : null}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/RoundTypeSelector/RoundTypeSelector.jsx